module.exports = __webpack_public_path__ + "static/media/warning_white.934bbd12.svg";